<style>
  table.dataTable {
    clear: both;
    margin-top: 6px !important;
    margin-bottom: 6px !important;
    max-width: none !important;
    border-collapse: separate !important;
    border-spacing: 0
}

table.dataTable td,
table.dataTable th {
    -webkit-box-sizing: content-box;
    box-sizing: content-box
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
    text-align: center
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
    white-space: nowrap
}

div.dataTables_wrapper div.dataTables_length label {
    font-weight: normal;
    text-align: left;
    white-space: nowrap
}

div.dataTables_wrapper div.dataTables_length select {
    width: auto;
    display: inline-block
}

div.dataTables_wrapper div.dataTables_filter {
    text-align: right
}

div.dataTables_wrapper div.dataTables_filter label {
    font-weight: normal;
    white-space: nowrap;
    text-align: left
}

div.dataTables_wrapper div.dataTables_filter input {
    margin-left: .5em;
    display: inline-block;
    width: auto
}

div.dataTables_wrapper div.dataTables_info {
    padding-top: .85em
}

div.dataTables_wrapper div.dataTables_paginate {
    margin: 0;
    white-space: nowrap;
    text-align: right
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    margin: 2px 0;
    white-space: nowrap;
    justify-content: flex-end
}

div.dataTables_wrapper div.dataTables_processing {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    margin-left: -100px;
    margin-top: -26px;
    text-align: center;
    padding: 1em 0
}

table.dataTable>thead>tr>th:active,
table.dataTable>thead>tr>td:active {
    outline: none
}

table.dataTable>thead>tr>th:not(.sorting_disabled),
table.dataTable>thead>tr>td:not(.sorting_disabled) {
    padding-right: 30px
}

table.dataTable>thead .sorting,
table.dataTable>thead .sorting_asc,
table.dataTable>thead .sorting_desc,
table.dataTable>thead .sorting_asc_disabled,
table.dataTable>thead .sorting_desc_disabled {
    cursor: pointer;
    position: relative
}

table.dataTable>thead .sorting:before,
table.dataTable>thead .sorting:after,
table.dataTable>thead .sorting_asc:before,
table.dataTable>thead .sorting_asc:after,
table.dataTable>thead .sorting_desc:before,
table.dataTable>thead .sorting_desc:after,
table.dataTable>thead .sorting_asc_disabled:before,
table.dataTable>thead .sorting_asc_disabled:after,
table.dataTable>thead .sorting_desc_disabled:before,
table.dataTable>thead .sorting_desc_disabled:after {
    position: absolute;
    bottom: .9em;
    display: block;
    opacity: .3
}

table.dataTable>thead .sorting:before,
table.dataTable>thead .sorting_asc:before,
table.dataTable>thead .sorting_desc:before,
table.dataTable>thead .sorting_asc_disabled:before,
table.dataTable>thead .sorting_desc_disabled:before {
    right: 1em;
    content: "↑"
}

table.dataTable>thead .sorting:after,
table.dataTable>thead .sorting_asc:after,
table.dataTable>thead .sorting_desc:after,
table.dataTable>thead .sorting_asc_disabled:after,
table.dataTable>thead .sorting_desc_disabled:after {
    right: .5em;
    content: "↓"
}

table.dataTable>thead .sorting_asc:before,
table.dataTable>thead .sorting_desc:after {
    opacity: 1
}

table.dataTable>thead .sorting_asc_disabled:before,
table.dataTable>thead .sorting_desc_disabled:after {
    opacity: 0
}

div.dataTables_scrollHead table.dataTable {
    margin-bottom: 0 !important
}

div.dataTables_scrollBody table {
    border-top: none;
    margin-top: 0 !important;
    margin-bottom: 0 !important
}

div.dataTables_scrollBody table thead .sorting:before,
div.dataTables_scrollBody table thead .sorting_asc:before,
div.dataTables_scrollBody table thead .sorting_desc:before,
div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
    display: none
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
    border-top: none
}

div.dataTables_scrollFoot>.dataTables_scrollFootInner {
    box-sizing: content-box
}

div.dataTables_scrollFoot>.dataTables_scrollFootInner>table {
    margin-top: 0 !important;
    border-top: none
}

@media screen and (max-width: 767px) {

    div.dataTables_wrapper div.dataTables_length,
    div.dataTables_wrapper div.dataTables_filter,
    div.dataTables_wrapper div.dataTables_info,
    div.dataTables_wrapper div.dataTables_paginate {
        text-align: center
    }

    div.dataTables_wrapper div.dataTables_paginate ul.pagination {
        justify-content: center !important
    }
}

table.dataTable.table-sm>thead>tr>th:not(.sorting_disabled) {
    padding-right: 20px
}

table.dataTable.table-sm .sorting:before,
table.dataTable.table-sm .sorting_asc:before,
table.dataTable.table-sm .sorting_desc:before {
    top: 5px;
    right: .85em
}

table.dataTable.table-sm .sorting:after,
table.dataTable.table-sm .sorting_asc:after,
table.dataTable.table-sm .sorting_desc:after {
    top: 5px
}

table.table-bordered.dataTable {
    border-right-width: 0
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
    border-left-width: 0
}

table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
    border-right-width: 1px
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
    border-bottom-width: 0
}

div.dataTables_scrollHead table.table-bordered {
    border-bottom-width: 0
}

div.table-responsive>div.dataTables_wrapper>div.row {
    margin: 0
}

div.table-responsive>div.dataTables_wrapper>div.row>div[class^=col-]:first-child {
    padding-left: 0
}

div.table-responsive>div.dataTables_wrapper>div.row>div[class^=col-]:last-child {
    padding-right: 0
}


.nav-link {
    color: black !important;
}

.main-sidebar {
    background-color: white !important;
}

.newcolor {
    color: #015792 !important;
}

::ng-deep {
    .sidebar-open #sidebar-overlay {
        display: none !important;
        z-index: 1 !important;
    }
}

.sidebar {
    /* Default sidebar styles (e.g., position, width, background-color) */
    display: block;
    /* Initial display for larger screens */
}

.sidebar.visible {
    display: block;
}


.img-circle {
    border-radius: 30% !important;
}

@media only screen and (max-width: 700px) {

    .forImgTxt {
        display: flex;
        align-items: center;
        margin-left: 5%;
        margin-top: 3%;
        margin-right: 10%;
        font-weight: bold;
    }

    .forImg {
        width: 15%;
        margin-top: 1%;
    }
}

@media only screen and (min-width: 700px) {

    .forImgTxt {
        display: flex;
        align-items: center;
        margin-left: 10px;
        margin-top: 3%;
        /* margin-right: 50px; */
        font-weight: bold;
    }

    .forImg {
        height: 50px;
        /* // width: 50px; */
        margin-left: 450px;
    }

    .forHeigh {
        height: 50px;
    }
}
</style>
<div class="wrapper">

  <!-- Preloader -->
  <!-- <div class="preloader flex-column justify-content-center align-items-center">
    <img class="animation__shake" src="assets/dist/img/AdminLTELogo.png" alt="AdminLTELogo" height="60" width="60">
  </div> -->

  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <div class="navbar-nav forHeigh">
        <li class="nav-item">
            <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
        </li>
        <div class="row" style="justify-content: center;align-items: center;">
         <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2 forImg" style="opacity: .8;border-radius: 30% !important">
         <h5  class="forImgTxt">MyRoots</h5>
        </div>  <!-- <li class="nav-item d-none d-sm-inline-block">
      <a href="index3.html" class="nav-link">Home</a>
    </li>style=""
    <li class="nav-item d-none d-sm-inline-block">
      <a href="#" class="nav-link">Contact</a>
    </li> -->
  </div>

    <!-- Right navbar links -->
    
</nav>
  <!-- /.navbar -->

  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-primary elevation-4" style="background-color: white;position: fixed;">
    <!-- Brand Logo -->
    <a style="display: inline-flex;padding-top: 10px;
    padding-left: 80px;color:#015792;">
      <img src="assets/dmk.png" alt="AdminLTE Logo" class="img-circle elevation-2"
        style="opacity: .8;width:40%; border-radius: 30% !important;">
      <span class="brand-text " style="margin-left: 10px;margin-top:15px;"></span>
    </a>
    <!-- Sidebar -->
    <div class="sidebar" style="background-color: white; height: calc(100vh - 85px); overflow-y: auto;">
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3  d-flex">

        <div class=" ">
          <a class="d-block newcolor" style="color: #015792;">SUPER ADMIN</a>
        </div>
      </div>

      <!-- SidebarSearch Form -->
      <!-- <div class="form-inline">
        <div class="input-group" data-widget="sidebar-search">
          <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
          <div class="input-group-append">
            <button class="btn btn-sidebar">
              <i class="fas fa-search fa-fw"></i>
            </button>
          </div>
        </div>
      </div> -->


      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false"
          style="height:100%;">
          <li class="nav-item">
            <a [routerLink]="['Dashboard']" class="nav-link" style="color:black;" data-widget="pushmenu">
              <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="none" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M20 19v-8.5a1 1 0 0 0-.4-.8l-7-5.25a1 1 0 0 0-1.2 0l-7 5.25a1 1 0 0 0-.4.8V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1M8 13v3m4-6v6m4-1v1" />
                </svg></i>
              <p style="margin-left: 8px;">
                Dashboard
              </p>
            </a>
          </li>

          <!-- <li class="nav-item">
                  <a  [routerLink]="['Dashboard']" class="nav-link">
                    <i class=""></i>
                      
                     </p>
                  </a>
                </li> -->
          <!-- <li class="nav-item">
                  <a  [routerLink]="['Stateadmin']" class="nav-link">
                    <i class=""></i>
                    <p>
                      State Body
                     </p>
                  </a>
                </li>
                <li class="nav-item">
                  <a  [routerLink]="['Districtadmin']" class="nav-link">
                    <i class=""></i>
                    <p>
                      District Admin
                     </p>
                  </a>
                </li> -->
          <!-- <li class="nav-item">
                  <a  [routerLink]="['Approve-Reject']" class="nav-link">
                    <i class=""></i>
                    <p>
                      Office Bearer
                     </p>
                  </a>
                </li>
                <li class="nav-item">
                  <a  [routerLink]="['office-bearer-approval']" class="nav-link">
                    <i class=""></i>
                    <p>
                      Office Bearer Approval
                     </p>
                  </a>
                </li> -->
          <!-- <li class="nav-item">
                  <a  [routerLink]="['Addtional-post-approval']" class="nav-link">
                    <i class=""></i>
                    <p>
                      Addtional Post Request Approval
                     </p>
                  </a>
                </li> -->
          <!-- <li class="nav-item">
                  <a  [routerLink]="['Meetings']" class="nav-link">
                    <i class=""></i>
                    <p>
                      Meetings
                     </p>
                  </a>
                </li> -->
          <!-- <li class="nav-item">
                  <a href="javascript:void(0)" class="nav-link">
                    <i></i>
                    <p> Tasks / Activity</p>
                  </a>
                </li>
                 <li class="nav-item" style="padding-left: 15px;"> -->
          <!-- <a  [routerLink]="['app-kalaignar100']" class="nav-link"> -->
          <!-- <a  [routerLink]="['Winner-List']" class="nav-link">
                    <i class=""></i>
                    <p>
                     Kalaignar100 Winnner List</p>
                  </a>
                </li> -->
          <!-- <li class="nav-item">
                  <a href="javascript:void(0)" class="nav-link">
                    <i></i>
                    <p>Reports</p>
                  </a>
                </li> -->
          <!-- <ul class="nav-item " style="padding-left: 15px;"> Adjust the padding as needed -->
          <!-- <li class="nav-item" style="padding-left: 15px;">
                      <a [routerLink]="['da-report']" class="nav-link">
                        <i class=""></i>
                        <p>District Enrollment Report</p>
                      </a>
                    </li>
                    <li class="nav-item" style="padding-left: 15px;">
                      <a  [routerLink]="['ob-report']" class="nav-link">
                        <i class=""></i>
                        <p>
                          Categorized By District
                         </p>
                      </a>
                    </li>
                    <li class="nav-item" style="padding-left: 15px;">
                      <a  [routerLink]="['da-address']" class="nav-link">
                        <i class=""></i>
                        <p>
                          District Admin Address Report
                         </p>
                      </a>
                    </li>
          
                    <li class="nav-item" style="padding-left: 15px;">
                      <a  [routerLink]="['zone-report']" class="nav-link">
                        <i class=""></i>
                        <p>
                          Zone Wise Report
                         </p>
                      </a>
                      </li>
                      <li class="nav-item" style="padding-left: 15px;">
                        <a  [routerLink]="['Winner_List_show']" class="nav-link">
                          <i class=""></i>
                          <p>
                            Kalaignar100 District wise Winnner Report
                           </p>
                        </a>
                        </li>
                      <li class="nav-item" >
                        <a  href="#" class="nav-link">
                          <i class=""></i>
                          <p>
                            Activity/Task
                          </p>
                        </a>
                      </li>
                    <li class="nav-item" style="margin-left: 10px;">
                      <a [routerLink]="['activity']" href="#" class="nav-link">
                        <i class=""></i>
                        <p>
                          Activity/Task Dashboard
                        </p>
                      </a>
                    </li>
                    <li class="nav-item" style="margin-left: 10px;">
                      <a [routerLink]="['activity-summary']" href="#" class="nav-link">
                        <i class=""></i>
                        <p>
                          Activity Summary
                        </p>
                      </a>
                    </li> -->
          <li class="nav-item">
            <a [routerLink]="['mc-list']" href="#" class="nav-link" data-widget="pushmenu">
              <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M11 14h2q.425 0 .713-.288T14 13q0-.425-.288-.712T13 12h-2q-.425 0-.712.288T10 13q0 .425.288.713T11 14m0-3h6q.425 0 .713-.288T18 10q0-.425-.288-.712T17 9h-6q-.425 0-.712.288T10 10q0 .425.288.713T11 11m0-3h6q.425 0 .713-.288T18 7q0-.425-.288-.712T17 6h-6q-.425 0-.712.288T10 7q0 .425.288.713T11 8M8 18q-.825 0-1.412-.587T6 16V4q0-.825.588-1.412T8 2h12q.825 0 1.413.588T22 4v12q0 .825-.587 1.413T20 18zm-4 4q-.825 0-1.412-.587T2 20V7q0-.425.288-.712T3 6q.425 0 .713.288T4 7v13h13q.425 0 .713.288T18 21q0 .425-.288.713T17 22z" />
                </svg></i>
              <p style="color:black;margin-left: 8px;">
                Course
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['attendance']" href="#" class="nav-link" data-widget="pushmenu">
              <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M11 14h2q.425 0 .713-.288T14 13q0-.425-.288-.712T13 12h-2q-.425 0-.712.288T10 13q0 .425.288.713T11 14m0-3h6q.425 0 .713-.288T18 10q0-.425-.288-.712T17 9h-6q-.425 0-.712.288T10 10q0 .425.288.713T11 11m0-3h6q.425 0 .713-.288T18 7q0-.425-.288-.712T17 6h-6q-.425 0-.712.288T10 7q0 .425.288.713T11 8M8 18q-.825 0-1.412-.587T6 16V4q0-.825.588-1.412T8 2h12q.825 0 1.413.588T22 4v12q0 .825-.587 1.413T20 18zm-4 4q-.825 0-1.412-.587T2 20V7q0-.425.288-.712T3 6q.425 0 .713.288T4 7v13h13q.425 0 .713.288T18 21q0 .425-.288.713T17 22z" />
                </svg></i>
              <p style="color:black;margin-left: 8px;">
                Course Attendance
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['superadminstudents']" href="#" class="nav-link" data-widget="pushmenu">
              <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black" fill-rule="evenodd"
                    d="M20 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm2 5h2v2H6zm5 0a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-3 4H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-2 3H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
                    clip-rule="evenodd" />
                </svg></i>
              <p style="color:black;margin-left: 8px;">
                Student List
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['superadminmentors']" href="#" class="nav-link" data-widget="pushmenu">
              <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black" fill-rule="evenodd"
                    d="M20 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm2 5h2v2H6zm5 0a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-3 4H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-2 3H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
                    clip-rule="evenodd" />
                </svg></i>
              <p style="color:black;margin-left: 8px;">
                Mentor List
              </p>
            </a>
          </li>

          <!-- </li> -->
          <!--                   
                <li class="nav-item">
                  <a  [routerLink]="['da-report']" class="nav-link">
                    <i class=""></i>
                    <p>
                      District Enrollment Report
                     </p>
                  </a>
                  </li>
                  <li class="nav-item">
                    <a  [routerLink]="['ob-report']" class="nav-link">
                      <i class=""></i>
                      <p>
                        District Bearer Report
                       </p>
                    </a>
                    </li> -->

          <!-- <li class="nav-item">
                    <a  [routerLink]="['menu-change-password']" class="nav-link">
                      <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                        <path fill="black"
                          d="M12 17a2 2 0 0 0 2-2a2 2 0 0 0-2-2a2 2 0 0 0-2 2a2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 5-5a5 5 0 0 1 5 5v2zm-6-5a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3" />
                      </svg></i>
                      <p style="color:black;margin-left: 8px;">
                        Change Password
                       </p>
                    </a>
                  </li> -->
          <!-- <li class="nav-item">
                    <a  [routerLink]="['profile']" class="nav-link">
                      <i class=""></i>
                      <p>
                        Profile
                       </p>
                    </a>
                  </li> -->

          <li class="nav-item">
            <a class="nav-link">
              <i class=""><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="black"
                    d="M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33a1 1 0 0 0 0-.76a1 1 0 0 0-.21-.33l-4-4a1 1 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1M17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3" />
                </svg></i>
              <p style="color:black;margin-left: 8px;" (click)="signout()">
                Sign Out
              </p>
            </a>
          </li>

        </ul>

      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <!--  -->
    <!-- /.content-header -->
    <div style="min-height: 600px;">
      <router-outlet></router-outlet>
    </div>
    <div class="footer">
      <div class="text-center p-3">
        <p>Copyright © MyRoots. Developed by <a  target="_blank"><strong>RedMind Technologies</strong></a> {{footerdate}}</p>
        <p>
          <i class="fa fa-phone" style="font-size:16px"></i>
          <strong> 7200749261</strong>
        </p>
      </div>
    </div>
  </div>
  <!-- /.content-wrapper -->
  <!-- <footer class="main-footer">
    <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 3.2.0
    </div>
  </footer> -->

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->
</div>